import React, { useContext, useEffect, useState } from 'react';
import { RefertoContext } from 'app/context/RefertoContext';

// Componenti appena creati
import PrecedentiEsamiForm from './PrecedentiEsamiForm';
import PrecedentiEsamiList from './PrecedentiEsamiList';

const PrecedentiEsami = ({ isRsa = false }) => {
    const { state: referto, dispatch: dispatchReferto } = useContext(RefertoContext);
    const precedentiEsami = referto.precedentiEsami
    const [showForm, setShowForm] = useState(!precedentiEsami || precedentiEsami.length == 0);
    const handleAddEsame = (nuovoEsame) => {
        dispatchReferto({
            type: "APPEND_TO_LIST",
            field: "precedentiEsami",
            payload: nuovoEsame
        });
        setShowForm(false);
    };

    const handleUpdateEsame = (index, updatedEsame) => {
        dispatchReferto({
            type: "UPDATE_LIST_ITEM",
            field: "precedentiEsami", // o il nome corretto del campo da aggiornare
            index: index,
            payload: updatedEsame,
        });
    };

    const handleRemoveEsame = (index) => {
        dispatchReferto({
            type: "REMOVE_LIST_ITEM",
            field: "precedentiEsami", // o il nome corretto del campo da aggiornare
            index: index,
            //payload: updatedEsame,
        });
    };

    useEffect(() => {
        setShowForm(!precedentiEsami || precedentiEsami.length == 0);
    }, [precedentiEsami])

    return (
        <div className="container">
            <PrecedentiEsamiList
                precedentiEsami={precedentiEsami}
                onUpdate={handleUpdateEsame}
                onRemove={handleRemoveEsame}
            />

            {!showForm && (
                <button
                    className="btn btn-secondary mt-3"
                    onClick={() => setShowForm(true)}
                >
                    Aggiungi Esame
                </button>
            )}

            {showForm && (
                <div className="mt-4">
                    <PrecedentiEsamiForm
                        isRsa={isRsa}
                        precedentiEsami={precedentiEsami}
                        onSubmit={handleAddEsame}
                        onCancel={() => setShowForm(false)}
                    />
                </div>
            )}
        </div>
    );
};

export default PrecedentiEsami;
